import "./App.css";
import Loader from "./Components/Loader/Loader";

function App() {
	return (
		<div className="App">
			<header className="App-header">
				<Loader></Loader>
				<p className="font-press-start">Here we are.</p>
			</header>
		</div>
	);
}

export default App;
